









import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import StaffEdit from "@/templates/StaffEdit.vue";
import SaveStaffRequest from "@/usecases/requests/save-staff-request";
import { Company, deleteStaff, getOurCompanies } from "@/api/company-api";
import { getServiceRoles } from "@/api/service-api";
import Role from "@/entities/role";
import TaskType from "@/entities/task-type";

@Component({
  components: {
    StaffEdit
  }
})
export default class OurStaffEditPage extends Vue {
  @Prop({ required: true }) id!: string;

  req = new SaveStaffRequest();
  companies: Company[] = [];
  roles: Role[] = [];
  errors: string[] = [];

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }

  async ok() {
    if (this.service.scheduleNotification && !this.req.scheduleNotification) {
      if (confirm("工程表移動チャットが送信されませんがよろしいですか？")) {
        await this.save();
        return;
      } else {
        return;
      }
    } else if (
      !this.service.scheduleNotification &&
      this.req.scheduleNotification
    ) {
      alert("工程表移動チャット機能をONにしてください");
      return;
    }
    await this.save();
  }

  cancel() {
    this.$router.push({ name: "our-staff-list" });
  }

  async remove() {
    await this.destroy();
    this.$router.push({ name: "our-staff-list" });
  }

  private async created() {
    this.$store.dispatch("tasktype/init");
    this.initServiceRoles();
    await this.initCompanies();
    this.edit();
  }

  @Watch("id")
  private async edit() {
    this.req = await this.$store.dispatch("editStaff", this.id);
  }

  private async initCompanies() {
    this.companies = _.orderBy(await getOurCompanies(), "furigana", "asc");
  }

  private async initServiceRoles() {
    this.roles = await getServiceRoles();
  }

  private async save() {
    try {
      await this.$store.dispatch("saveStaff", this.req);
      this.$router.push({ name: "our-staff-list" });
    } catch (e) {
      return (this.errors = e as []);
    }
  }

  private async destroy() {
    await deleteStaff(this.id);
  }

  get service() {
    return this.$store.state.service;
  }
}
